"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HotelsPriceTable;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _utils = require("@whitbread-eos/utils");
var _framerMotion = require("framer-motion");
var _nextI18next = require("next-i18next");
var _react2 = _interopRequireWildcard(require("react"));
var _FloatingHeader = require("./FloatingHeader");
var _SkeletonTableRow = require("./SkeletonTableRow");
var _TableHeader = require("./TableHeader");
var _constants = require("./constants");
var _helpers = require("./helpers");
var _hooks = require("./hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HotelsPriceTable() {
  var {
    sortBy: externalSortBy,
    onSortChange,
    data: externalData,
    isLoading: externalIsLoading,
    isError: externalIsError,
    locationId,
    formattedDate,
    onDateChange,
    onCurrentDatesChange,
    onSortedByDateChange,
    locale = 'en-GB',
    setLowestPrice,
    setIsLoading,
    currentPage = 1,
    setTotalItems,
    onPriceSortChange,
    sortResetKey,
    locationName
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var [isMobile] = (0, _react.useMediaQuery)('(max-width: 767px)');
  var [isSmallerThanSm] = (0, _react.useMediaQuery)('(max-width: 575px)');
  var [isLargeScreen] = (0, _react.useMediaQuery)('(min-width: 1024px)');
  var tableHeaderRef = (0, _react2.useRef)(null);
  var [internalSortBy, setInternalSortBy] = (0, _react2.useState)(_constants.SORT_BY_VALUES.DISTANCE);
  var [priceSortDate, setPriceSortDate] = (0, _react2.useState)(null);
  var [hoveredHotelIdx, setHoveredHotelIdx] = (0, _react2.useState)(null);
  var sortBy = externalSortBy !== null && externalSortBy !== void 0 ? externalSortBy : internalSortBy;
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  var {
    language,
    country
  } = (0, _utils.useCustomLocale)();
  var {
    currentDates,
    currentStartDate,
    arrival,
    handleScrollLeft,
    handleScrollRight,
    isScrollLeftDisabled,
    isScrollRightDisabled
  } = (0, _hooks.useDateNavigation)(onDateChange, formattedDate);
  (0, _react2.useEffect)(() => {
    if (sortBy === _constants.SORT_BY_VALUES.DISTANCE) {
      setPriceSortDate(null);
    }
  }, [sortBy]);
  (0, _react2.useEffect)(() => {
    if (typeof sortResetKey !== 'undefined') {
      setPriceSortDate(null);
    }
  }, [sortResetKey]);
  (0, _react2.useEffect)(() => {
    setPriceSortDate(null);
  }, [locationId, formattedDate, arrival]);
  (0, _react2.useEffect)(() => {
    if (onCurrentDatesChange && currentDates.length > 0) {
      onCurrentDatesChange(currentDates);
    }
  }, [currentDates, onCurrentDatesChange]);
  (0, _react2.useEffect)(() => {
    if (onSortedByDateChange) {
      onSortedByDateChange(priceSortDate);
    }
  }, [priceSortDate, onSortedByDateChange]);
  var getColSpan = dateCount => {
    if (isMobile) {
      return dateCount + 2;
    } else {
      return dateCount + 3;
    }
  };
  var criteria = (0, _react2.useMemo)(() => {
    var actualSortBy = priceSortDate ? 'PRICE' : sortBy.toUpperCase();
    var baseCriteria = {
      locationId: locationId || _constants.DEFAULT_LOCATION_ID,
      arrival: formattedDate || arrival,
      daysRange: _constants.TABLE_CONFIG.DAYS_TO_SHOW,
      showMinimumNights: false,
      page: currentPage,
      initialPageSize: _constants.TABLE_CONFIG.PAGE_SIZE,
      lazyLoadPageSize: _constants.TABLE_CONFIG.LAZY_LOAD_PAGE_SIZE,
      sortBy: actualSortBy
    };
    if (actualSortBy === 'PRICE' && priceSortDate) {
      return _objectSpread(_objectSpread({}, baseCriteria), {}, {
        sortDate: priceSortDate
      });
    }
    return baseCriteria;
  }, [locationId, formattedDate, arrival, sortBy, priceSortDate, currentPage]);
  var shouldUseInternalQuery = !externalData && externalIsLoading === undefined && externalIsError === undefined;
  var {
    data: internalData,
    hotelData: internalHotelData,
    globalLowestPrice: internalGlobalLowestPrice,
    isLoading: internalIsLoading,
    isError: internalIsError
  } = (0, _hooks.useLowestRates)(criteria, currentDates, {
    enabled: shouldUseInternalQuery
  }, locationName);
  var data = externalData !== undefined ? externalData : internalData;
  var isLoading = externalIsLoading !== undefined ? externalIsLoading : internalIsLoading;
  var isError = externalIsError !== undefined ? externalIsError : internalIsError;
  var shouldUseInternalTransformedData = shouldUseInternalQuery && internalHotelData.length > 0;
  var {
    hotelData: externalHotelData,
    globalLowestPrice: externalGlobalLowestPrice
  } = (0, _hooks.useHotelData)({
    currentDates,
    currentStartDate,
    data: shouldUseInternalTransformedData ? null : data,
    isLoading: shouldUseInternalTransformedData ? false : isLoading,
    isError: shouldUseInternalTransformedData ? false : isError
  });
  var hotelData = shouldUseInternalTransformedData ? internalHotelData : externalHotelData;
  var globalLowestPrice = shouldUseInternalTransformedData ? internalGlobalLowestPrice : externalGlobalLowestPrice;
  var {
    showFloatingHeader
  } = (0, _hooks.useFloatingHeader)(tableHeaderRef);
  var {
    getLowestRatesByLocationId: {
      lowestMonthlyRate = null
    } = {}
  } = data || {};
  (0, _react2.useEffect)(() => {
    var _data$getLowestRatesB;
    if (setLowestPrice) {
      setLowestPrice(lowestMonthlyRate);
    }
    if (setIsLoading) {
      setIsLoading(isLoading);
    }
    if (setTotalItems && (data === null || data === void 0 || (_data$getLowestRatesB = data.getLowestRatesByLocationId) === null || _data$getLowestRatesB === void 0 ? void 0 : _data$getLowestRatesB.total) !== undefined) {
      setTotalItems(data.getLowestRatesByLocationId.total);
    }
  }, [data, isLoading, setLowestPrice, setIsLoading, setTotalItems]);
  var handleSortToggle = () => {
    setPriceSortDate(null);
    if (onSortChange) {
      onSortChange(_constants.SORT_BY_VALUES.DISTANCE);
    } else {
      setInternalSortBy(_constants.SORT_BY_VALUES.DISTANCE);
    }
  };
  var handleDateSortForPrice = date => {
    setPriceSortDate(date);
    if (onPriceSortChange) {
      onPriceSortChange();
    }
  };
  var handleScrollLeftWithReset = () => {
    setPriceSortDate(null);
    if (onSortChange) {
      onSortChange(_constants.SORT_BY_VALUES.DISTANCE);
    } else {
      setInternalSortBy(_constants.SORT_BY_VALUES.DISTANCE);
    }
    handleScrollLeft();
  };
  var handleScrollRightWithReset = () => {
    setPriceSortDate(null);
    if (onSortChange) {
      onSortChange(_constants.SORT_BY_VALUES.DISTANCE);
    } else {
      setInternalSortBy(_constants.SORT_BY_VALUES.DISTANCE);
    }
    handleScrollRight();
  };
  var handleHotelRedirect = (hotelLink, price, selectedDate) => {
    if (hotelLink && price) {
      var queryParams = (0, _helpers.buildHotelQueryParams)(selectedDate);
      var finalUrl = "/".concat(country, "/").concat(language, "/hotels").concat(hotelLink, ".html?").concat(queryParams);
      window.open(finalUrl, '_blank');
    }
  };
  var getColumnWidth = () => {
    if (isSmallerThanSm) return '22px';
    if (isMobile) return '40px';
    if (isLargeScreen) return '82.55px';
    return '54px';
  };
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
      children: showFloatingHeader && (0, _jsxRuntime.jsx)(_FloatingHeader.FloatingHeader, {
        currentDates: currentDates,
        sortedByDate: priceSortDate,
        handleDateSort: handleDateSortForPrice,
        handleScrollLeft: handleScrollLeftWithReset,
        handleScrollRight: handleScrollRightWithReset,
        isScrollLeftDisabled: isScrollLeftDisabled,
        isScrollRightDisabled: isScrollRightDisabled,
        isLoading: isLoading,
        isMobile: isMobile,
        isSmallerThanSm: isSmallerThanSm,
        handleSortToggle: handleSortToggle,
        locale: locale,
        getColumnWidth: getColumnWidth
      }, "floating-header")
    }), (0, _jsxRuntime.jsxs)(_react.Table, _objectSpread(_objectSpread({}, styles.table), {}, {
      "data-testid": "hotel-price-table",
      style: {
        tableLayout: 'fixed',
        minWidth: isMobile ? '280px' : 'auto'
      },
      children: [(0, _jsxRuntime.jsxs)("colgroup", {
        children: [!isMobile && (0, _jsxRuntime.jsx)("col", {
          style: styles.hotelNameCol
        }), (0, _jsxRuntime.jsx)("col", {
          style: {
            width: isMobile ? '24px' : '40px'
          }
        }), currentDates.map((_, idx) => (0, _jsxRuntime.jsx)("col", {
          style: {
            width: getColumnWidth()
          }
        }, idx)), (0, _jsxRuntime.jsx)("col", {
          style: {
            width: isMobile ? '24px' : '40px'
          }
        })]
      }), (0, _jsxRuntime.jsx)(_TableHeader.TableHeader, {
        currentDates: currentDates,
        sortedByDate: priceSortDate,
        handleDateSort: handleDateSortForPrice,
        handleScrollLeft: handleScrollLeftWithReset,
        handleScrollRight: handleScrollRightWithReset,
        isScrollLeftDisabled: isScrollLeftDisabled,
        isScrollRightDisabled: isScrollRightDisabled,
        isLoading: isLoading,
        isMobile: isMobile,
        isSmallerThanSm: isSmallerThanSm,
        tableHeaderRef: tableHeaderRef,
        handleSortToggle: handleSortToggle,
        locale: locale
      }), (0, _jsxRuntime.jsx)(_react.Tbody, {
        "data-testid": "hotel-price-table-body",
        sx: isLoading ? {
          height: isMobile ? '1540px' : '980px'
        } : {},
        children: isLoading ? (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: Array.from({
            length: _constants.TABLE_CONFIG.SKELETON_ROWS_COUNT
          }, (_, idx) => (0, _jsxRuntime.jsx)(_SkeletonTableRow.SkeletonTableRow, {
            isMobile: isMobile,
            currentDates: currentDates,
            index: idx
          }, "skeleton-".concat(idx)))
        }) : isError ? (0, _jsxRuntime.jsx)(_react.Tr, {
          "data-testid": "error-row",
          bg: _constants.THEME_COLORS.primaryRowBg,
          children: (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({}, styles.errorCell), {}, {
            colSpan: getColSpan(_constants.TABLE_CONFIG.DAYS_TO_SHOW),
            children: (0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({}, styles.errorContainer), {}, {
              children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.errorTitle), {}, {
                "data-testid": "error-message-title",
                children: t('priceFinder.noResults.title')
              })), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.errorDescription), {}, {
                "data-testid": "error-message-description",
                children: t('priceFinder.noResults.description')
              }))]
            }))
          }))
        }) : hotelData.length === 0 ? (0, _jsxRuntime.jsx)(_react.Tr, {
          "data-testid": "no-data-row",
          bg: _constants.THEME_COLORS.primaryRowBg,
          children: (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({}, styles.errorCell), {}, {
            colSpan: getColSpan(_constants.TABLE_CONFIG.DAYS_TO_SHOW),
            children: (0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({}, styles.errorContainer), {}, {
              children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.errorTitle), {}, {
                "data-testid": "no-data-message",
                children: t('priceFinder.noResults.title')
              })), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.errorDescription), {}, {
                "data-testid": "no-data-description",
                children: t('priceFinder.noResults.description')
              }))]
            }))
          }))
        }) : hotelData.map((hotel, hIdx) => isMobile ? (0, _jsxRuntime.jsxs)(_react2.default.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_react.Tr, _objectSpread(_objectSpread({
            "data-testid": "hotel-row-name-".concat(hIdx),
            bg: hoveredHotelIdx === hIdx ? styles.mobileHotelNamePricesRow._hover.bg : hIdx % 2 === 0 ? _constants.THEME_COLORS.primaryRowBg : _constants.THEME_COLORS.alternateRowBg
          }, styles.mobileHotelNameRow), {}, {
            onMouseEnter: () => setHoveredHotelIdx(hIdx),
            onMouseLeave: () => setHoveredHotelIdx(null),
            children: (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({
              colSpan: getColSpan(currentDates.length)
            }, styles.mobileHotelNameCell), {}, {
              children: hotel.hotelName
            }))
          })), (0, _jsxRuntime.jsxs)(_react.Tr, _objectSpread(_objectSpread({
            "data-testid": "hotel-row-prices-".concat(hIdx),
            bg: hoveredHotelIdx === hIdx ? styles.mobileHotelNamePricesRow._hover.bg : hIdx % 2 === 0 ? _constants.THEME_COLORS.primaryRowBg : _constants.THEME_COLORS.alternateRowBg
          }, styles.mobilePricesRow), {}, {
            onMouseEnter: () => setHoveredHotelIdx(hIdx),
            onMouseLeave: () => setHoveredHotelIdx(null),
            children: [(0, _jsxRuntime.jsx)(_react.Td, _objectSpread({
              "data-testid": "hotel-spacer-left-".concat(hIdx)
            }, styles.spacerCell)), hotel.prices.map((price, idx) => {
              var dateForThisPrice = currentDates[idx];
              var isCurrentSort = priceSortDate === dateForThisPrice;
              var formattedPrice = price.amount ? (0, _utils.formatPrice)((0, _utils.formatCurrency)(price.currency), price.amount, language) : '\u2501';
              var priceStyle = (0, _helpers.getPriceStyle)(price.amount, globalLowestPrice, parseInt(t('priceFinder.MVP.customConfig.highlightedPriceRange') || '5'));
              var cellBg = isCurrentSort ? _constants.THEME_COLORS.sortedCellBg : 'transparent';
              return (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({
                "data-testid": "price-cell-".concat(hIdx, "-").concat(idx),
                bg: cellBg,
                "aria-label": price.amount ? "".concat(hotel.hotelName, " price on ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                  locale
                }).weekday, " ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                  locale
                }).day, ": ").concat(formattedPrice) : "".concat(hotel.hotelName, " not available on ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                  locale
                }).weekday, " ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                  locale
                }).day),
                cursor: hotel.hotelLink && price.amount ? 'pointer' : 'default',
                onClick: () => handleHotelRedirect(hotel.hotelLink, price.amount, dateForThisPrice)
              }, styles.mobilePriceCell), {}, {
                children: (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({
                  bg: priceStyle.textBg,
                  color: priceStyle.color,
                  fontWeight: priceStyle.fontWeight || 'normal',
                  px: priceStyle.textBg !== 'transparent' ? {
                    base: 1,
                    xs: 2
                  } : 0,
                  py: priceStyle.textBg !== 'transparent' ? {
                    base: 0.5,
                    xs: 1
                  } : 0,
                  my: isMobile && priceStyle.textBg !== 'transparent' ? '2px' : 0,
                  _hover: {
                    textDecoration: hotel.hotelLink && price.amount ? 'underline' : 'none'
                  }
                }, styles.priceBox), {}, {
                  children: formattedPrice
                }))
              }), idx);
            }), (0, _jsxRuntime.jsx)(_react.Td, _objectSpread({
              "data-testid": "hotel-spacer-right-".concat(hIdx)
            }, styles.spacerCell))]
          }))]
        }, hotel.hotelName) : (0, _jsxRuntime.jsxs)(_react.Tr, _objectSpread(_objectSpread({
          "data-testid": "hotel-row-".concat(hIdx),
          bg: hIdx % 2 === 0 ? _constants.THEME_COLORS.alternateRowBg : _constants.THEME_COLORS.primaryRowBg
        }, styles.hotelNamePricesRow), {}, {
          children: [(0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({
            "data-testid": "hotel-name-".concat(hIdx)
          }, styles.desktopHotelNameCell), {}, {
            children: hotel.hotelName
          })), (0, _jsxRuntime.jsx)(_react.Td, {
            "data-testid": "hotel-spacer-left-".concat(hIdx)
          }), hotel.prices.map((price, idx) => {
            var dateForThisPrice = currentDates[idx];
            var isCurrentSort = priceSortDate === dateForThisPrice;
            var formattedPrice = price.amount ? (0, _utils.formatPrice)((0, _utils.formatCurrency)(price.currency), price.amount, language) : '\u2501';
            var priceStyle = (0, _helpers.getPriceStyle)(price.amount, globalLowestPrice);
            var cellBg = isCurrentSort ? _constants.THEME_COLORS.sortedCellBg : 'transparent';
            return (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({
              "data-testid": "price-cell-".concat(hIdx, "-").concat(idx),
              bg: cellBg,
              "aria-label": price.amount ? "".concat(hotel.hotelName, " price on ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                locale
              }).weekday, " ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                locale
              }).day, ": ").concat(formattedPrice) : "".concat(hotel.hotelName, " not available on ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                locale
              }).weekday, " ").concat((0, _helpers.formatDate)(dateForThisPrice, {
                locale
              }).day),
              cursor: hotel.hotelLink && price.amount ? 'pointer' : 'default',
              _focus: {
                outline: '2px solid',
                outlineColor: _constants.THEME_COLORS.primaryColor,
                outlineOffset: '2px'
              },
              onClick: () => handleHotelRedirect(hotel.hotelLink, price.amount, dateForThisPrice)
            }, styles.desktopPriceCell), {}, {
              children: (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({
                bg: priceStyle.textBg,
                color: priceStyle.color,
                fontWeight: priceStyle.fontWeight || 'normal',
                px: priceStyle.textBg !== 'transparent' ? {
                  base: 1,
                  xs: 2
                } : 0,
                py: priceStyle.textBg !== 'transparent' ? {
                  base: 0.5,
                  xs: 1
                } : 0,
                _hover: {
                  textDecoration: hotel.hotelLink && price.amount ? 'underline' : 'none'
                }
              }, styles.priceBox), {}, {
                children: formattedPrice
              }))
            }), idx);
          }), (0, _jsxRuntime.jsx)(_react.Td, {
            "data-testid": "hotel-spacer-right-".concat(hIdx)
          })]
        }), hotel.hotelName))
      })]
    }))]
  });
}
var styles = {
  table: {
    variant: 'simple',
    size: 'sm',
    role: 'table'
  },
  hotelNameCol: {
    width: '50%'
  },
  errorCell: {
    textAlign: 'center',
    py: 12
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4
  },
  errorTitle: {
    fontSize: 'xl',
    fontWeight: 'semibold'
  },
  errorDescription: {
    fontSize: 'md'
  },
  mobileHotelNameRow: {
    transition: 'background-color 0.2s ease',
    sx: {
      borderBottom: 'none'
    }
  },
  mobileHotelNameCell: {
    fontWeight: {
      base: 600,
      md: 400
    },
    fontSize: {
      base: '14px',
      md: '16px'
    },
    textAlign: 'left',
    px: 2,
    py: 1,
    sx: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      borderBottom: 'none'
    }
  },
  mobilePricesRow: {
    transition: 'background-color 0.2s ease',
    sx: {
      borderTop: 'none'
    }
  },
  hotelNamePricesRow: {
    transition: 'background-color 0.2s ease',
    _hover: {
      bg: '#EBF4F6'
    }
  },
  mobileHotelNamePricesRow: {
    _hover: {
      bg: '#EBF4F6'
    }
  },
  spacerCell: {
    sx: {
      borderTop: 'none'
    }
  },
  mobilePriceCell: {
    textAlign: 'center',
    transition: 'background-color 0.2s ease',
    minW: '44px',
    w: '70px',
    fontSize: {
      base: 'xs',
      md: 'sm'
    },
    sx: {
      borderTop: 'none'
    },
    p: {
      base: '2px',
      md: '2'
    }
  },
  priceBox: {
    borderRadius: '4px',
    display: 'inline-block',
    textDecoration: 'none',
    transition: 'text-decoration 0.2s ease'
  },
  desktopRow: {
    transition: 'background-color 0.2s ease'
  },
  desktopHotelNameCell: {
    fontWeight: {
      base: 600,
      md: 400
    },
    scope: 'row',
    fontSize: {
      base: '14px',
      md: '16px'
    },
    w: '50%',
    sx: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  desktopPriceCell: {
    textAlign: 'center',
    transition: 'background-color 0.2s ease',
    minW: 'calc(50% / 7)',
    w: 'calc(50% / 7)',
    fontSize: {
      base: 'xs',
      md: 'sm'
    }
  }
};